export default __webpack_public_path__ + "static/access-digital-online-f492e6b8d1e5512d50745e714eecd92f.jpg";